import React, { FunctionComponent, useEffect, useState } from "react";
import styles from "../css/Section1.module.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import image from "../../assets/dummy_book.jpg";

import Select, { SelectChangeEvent } from "@mui/material/Select";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Section1: FunctionComponent = () => {
  const language = useSelector((state: any) => state.language.value);
  const [marketplace, setMarketplace] = useState("Amazon");

  const handleChange = (event: SelectChangeEvent) => {
    setMarketplace(event.target.value);
  };

  const navigate = useNavigate();

  const handleScroll = () => {
    navigate("/preview");
    setTimeout(() => {
      const element = document.querySelector(".mainContent");
      element?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  const handleScroll2 = () => {
    navigate("/#preview"); // Navigate with hash
  };

  // Language switch handler

  function SampleNextArrow(props) {
    const { onClick } = props;
    return (
      <svg
        className={styles.nextArrow}
        onClick={onClick}
        style={{ position: "absolute", zIndex: "22", right: "-2%", top: "45%" }}
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="17.5"
          cy="17.5"
          r="17"
          transform="rotate(-180 17.5 17.5)"
          fill="#C4B57C"
          stroke="#C4B57C"
        />
        <path
          d="M22.3536 17.3536C22.5488 17.1583 22.5488 16.8417 22.3536 16.6464L19.1716 13.4645C18.9763 13.2692 18.6597 13.2692 18.4645 13.4645C18.2692 13.6597 18.2692 13.9763 18.4645 14.1716L21.2929 17L18.4645 19.8284C18.2692 20.0237 18.2692 20.3403 18.4645 20.5355C18.6597 20.7308 18.9763 20.7308 19.1716 20.5355L22.3536 17.3536ZM-4.37114e-08 17.5L22 17.5L22 16.5L4.37114e-08 16.5L-4.37114e-08 17.5Z"
          fill="white"
        />
      </svg>
    );
  }

  function SamplePrevArrow(props) {
    const { onClick } = props;
    return (
      <svg
        className={styles.prevArrow}
        onClick={onClick}
        style={{ position: "absolute", zIndex: "22", left: "-2%", top: "45%" }}
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="17.5" cy="17.5" r="17" fill="#C4B57C" stroke="#C4B57C" />
        <path
          d="M12.6464 17.6464C12.4512 17.8417 12.4512 18.1583 12.6464 18.3536L15.8284 21.5355C16.0237 21.7308 16.3403 21.7308 16.5355 21.5355C16.7308 21.3403 16.7308 21.0237 16.5355 20.8284L13.7071 18L16.5355 15.1716C16.7308 14.9763 16.7308 14.6597 16.5355 14.4645C16.3403 14.2692 16.0237 14.2692 15.8284 14.4645L12.6464 17.6464ZM35 17.5L13 17.5V18.5L35 18.5V17.5Z"
          fill="white"
        />
      </svg>
    );
  }

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    dotsClass: "slick-dots customDots", // Custom class for styling
    appendDots: (dots) => (
      <div>
        <ul> {dots} </ul>
      </div>
    ),
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.zakazati}>
        <div className={styles.flexThis}>
          <div className={styles.spiritLiberContainer}>
            <span className={styles.spiritLiber}>
              {language === "EN" && "Free Spirit"}
              {language === "RO" && "Spirit Liber"}
              {language === "RU" && "Spirit Liber"}
            </span>
            <span className={styles.spiritLiber1}>
              {language === "EN" && "Spirit liber"}
              {language === "RO" && "Spirit liber"}
              {language === "RU" && "Spirit liber"}
            </span>
          </div>

          <span className={styles.authorMariannaMelnik}>
            <svg
              width="21"
              height="16"
              viewBox="0 0 21 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.645 15.7C15.5817 15.7 14.6283 15.37 13.785 14.71C12.9417 14.05 12.2817 13.225 11.805 12.235C11.3283 11.2083 11.09 10.1817 11.09 9.155C11.09 7.615 11.4933 6.31333 12.3 5.25C13.1433 4.18667 14.1883 3.30667 15.435 2.61C16.7183 1.91333 17.9833 1.38167 19.23 1.015C19.5967 0.868332 19.89 0.923332 20.11 1.18C20.3667 1.4 20.495 1.675 20.495 2.005C20.495 2.335 20.3117 2.57333 19.945 2.72C16.8283 3.89333 15.27 5.525 15.27 7.615C15.27 8.275 15.4717 8.825 15.875 9.265C16.315 9.66833 16.7917 10.035 17.305 10.365C17.855 10.6583 18.3317 11.0067 18.735 11.41C19.175 11.8133 19.395 12.3267 19.395 12.95C19.395 13.6467 19.12 14.2883 18.57 14.875C18.0567 15.425 17.415 15.7 16.645 15.7ZM5.645 15.7C4.58167 15.7 3.62833 15.37 2.785 14.71C1.94167 14.05 1.28167 13.225 0.805 12.235C0.328333 11.2083 0.0900001 10.1817 0.0900001 9.155C0.0900001 7.615 0.493333 6.31333 1.3 5.25C2.14333 4.18667 3.18833 3.30667 4.435 2.61C5.71833 1.91333 6.98333 1.38167 8.23 1.015C8.59667 0.868332 8.89 0.923332 9.11 1.18C9.36667 1.4 9.495 1.675 9.495 2.005C9.495 2.335 9.31167 2.57333 8.945 2.72C5.82833 3.89333 4.27 5.525 4.27 7.615C4.27 8.275 4.47167 8.825 4.875 9.265C5.315 9.66833 5.79167 10.035 6.305 10.365C6.855 10.6583 7.33167 11.0067 7.735 11.41C8.175 11.8133 8.395 12.3267 8.395 12.95C8.395 13.6467 8.12 14.2883 7.57 14.875C7.05667 15.425 6.415 15.7 5.645 15.7Z"
                fill="#C4B57C"
              />
            </svg>
            {language === "EN" && "by Mariana Melnic"}
            {language === "RO" && "de  Mariana Melnic"}
            {language === "RU" && "Автор — Марианна Мельник"}
          </span>
        </div>
        <span className={styles.authorInfo}>
          {language === "EN" && (
            <>
              The real challenge is not letting go, but the fear of moving
              forward. My dream was simple, yet profound: to free my spirit from
              external expectations and live happily. After traveling through
              various countries and meeting different people, I chose to share
              my story to inspire others, speaking about the struggles that
              taught me to fully discover myself: I – spirit. I – body. I –
              human.
              <br />
              <br />
              The book "FREE SPIRIT" is not just a travel journal. It is a
              sincere invitation to allow yourself to dream without limits and
              to truly live in freedom!
            </>
          )}
          {language === "RO" && (
            <>
              Adevărata provocare nu este renunțarea, ci frica de a merge mai
              departe. Visul meu a fost simplu, dar profund: să-mi eliberez
              spiritul de așteptările exterioare și să trăiesc fericită. După o
              călătorie prin diverse țări și întâlnire cu diverși oameni, am
              ales să împărtășesc povestea mea pentru a inspira, vorbind despre
              luptele care m-au învățat să mă descopăr pe mine însămi în
              întregime: Eu – spirit. Eu – corp. Eu – Om.
              <br />
              <br />
              Cartea "SPIRIT LIBER" nu este doar un jurnal de călătorie. Este o
              invitație sinceră de a-ți permite să visezi fără limite și de a
              trăi cu adevărat în libertate!
            </>
          )}{" "}
          {language === "RU" &&
            "Несколько строк об авторе и о книге. Таким образом, убеждённость некоторых оппонентов однозначно фиксирует необходимость анализа паттернов поведения."}
        </span>
        <div className={styles.buyContainer}>
          <div onClick={handleScroll} className={styles.frame2}>
            <span className={styles.orderBook}>
              {language === "EN" && `Order book`}
              {language === "RO" && `Comandă cartea`}
              {language === "RU" && "Заказать книгу"}
            </span>
          </div>
        </div>
        <div className={styles.orderBookPdfAudio} onClick={handleScroll2}>
          <span className={styles.orderBookPdfAudio3}>
            {language === "EN" && "Preview the book in PDF or Audio format"}
            {language === "RO" &&
              "Previzualizare cartea in format PDF sau audio"}
          </span>
        </div>
      </div>
      <div className={styles.carousel}>
        <Slider {...settings} className={styles.imageContainer}>
          <div>
            <img src={image} alt="Description" />
          </div>
          <div>
            <img src={image} alt="Description" />
          </div>
        </Slider>
      </div>
    </div>
  );
};

export default Section1;
